// Comments plan 3c (spec 2026-10-18-comments-design, Rev. 4): the commenter's browser, system and sizes, saved with a
// new thread. Read from the user agent text, which even in its reduced form still names the browser's major version and
// the system; the raw text itself is never stored.

const BROWSERS = [
  ['Edge', /Edg\/(\d+)/],
  ['Opera', /OPR\/(\d+)/],
  ['Firefox', /Firefox\/(\d+)/],
  ['Chrome', /Chrome\/(\d+)/],
  ['Safari', /Version\/(\d+)[.\d]* (?:Mobile\/\S+ )?Safari\//],
];
const SYSTEMS = [['iOS', /iPhone|iPad|iPod/], ['Android', /Android/], ['macOS', /Mac OS X/], ['Windows', /Windows/], ['Linux', /Linux|X11/]];

const size = (w, h) => (w > 0 && h > 0 ? { w: Math.round(w), h: Math.round(h) } : null);

/** `{ browser, os, screen, view, dpr }` with what could be read; view is the page area the person saw. */
export function clientSetup(nav, screen, view, dpr) {
  const ua = (nav && nav.userAgent) || '';
  const out = {};
  const browser = BROWSERS.map(([name, re]) => [name, ua.match(re)]).find(([, m]) => m);
  if (browser) out.browser = `${browser[0]} ${browser[1][1]}`;
  const os = SYSTEMS.find(([, re]) => re.test(ua));
  if (os) [out.os] = os;
  const s = screen && size(screen.width, screen.height);
  if (s) out.screen = s;
  const v = view && size(view.w, view.h);
  if (v) out.view = v;
  if (dpr > 0) out.dpr = dpr;
  return out;
}

/** "Chrome 141 · macOS · Bildschirm 1440×900 · Ansicht 390×720" ('' without a setup). */
export function setupLine(setup, t) {
  if (!setup) return '';
  return [
    setup.browser,
    setup.os,
    setup.screen && `${t('webmag.comments.screen')} ${setup.screen.w}×${setup.screen.h}`,
    setup.view && `${t('webmag.comments.view')} ${setup.view.w}×${setup.view.h}`,
  ].filter(Boolean).join(' · ');
}
